import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LazyLoaderService {
    constructor() {}

    public async dynamicImportFilterModule(moduleName): Promise<any> {
        switch (`${moduleName}FilterModule`) {
            case 'CalendarsFilterModule':
                return (await import('@components/report-filters/filters/calendars-filter/calendars-filter.module'))
                    .CalendarsFilterModule;
            case 'SitesFilterModule':
                return (await import('@components/report-filters/filters/sites-filter/sites-filter.module'))
                    .SitesFilterModule;
            case 'EventsFilterModule':
                return (await import('@components/report-filters/filters/events-filter/events-filter.module'))
                    .EventsFilterModule;
            case 'SelectFilterModule':
                return (await import('@components/report-filters/filters/select-filter/select-filter.module'))
                    .SelectFilterModule;
            case 'DestinationsFilterModule':
                return (
                    await import('@components/report-filters/filters/destinations-filter/destinations-filter.module')
                ).DestinationsFilterModule;
            case 'ViewFilterModule':
                return (await import('@components/report-filters/filters/view-filter/view-filter.module'))
                    .ViewFilterModule;
            case 'JobCategoriesFilterModule':
                return (
                    await import('@components/report-filters/filters/job-categories-filter/job-categories-filter.module')
                ).JobCategoriesFilterModule;
            case 'EmployeesFilterModule':
                return (await import('@components/report-filters/filters/employees-filter/employees-filter.module'))
                    .EmployeesFilterModule;
            case 'CombinedSelectFilterModule':
                return (
                    await import('@components/report-filters/filters/combined-select-filter/combined-select-filter.module')
                ).CombinedSelectFilterModule;
            case 'CheckboxFilterModule':
                return (await import('@components/report-filters/filters/checkbox-filter/checkbox-filter.module'))
                    .CheckboxFilterModule;
            case 'BusinessRuleGroupFilterModule':
                return (
                    await import('@components/report-filters/filters/business-rule-group-filter/business-rule-group-filter.module')
                ).BusinessRuleGroupFilterModule;
            case 'ConfigurableSitesFilterModule':
                return (
                    await import('@components/report-filters/filters/configurable-sites-filter/configurable-sites-filter.module')
                ).ConfigurableSitesFilterModule;
            case 'DayPartsFilterModule':
                return (await import('@components/report-filters/filters/day-parts-filter/day-parts-filter.module'))
                    .DayPartsFilterModule;
        }
    }

    public async dynamicImportSsrsReportModule(): Promise<any> {
        return (await import('@containers/reports/report/ssrs/i-frame-report.module')).IFrameReportModule;
    }

    public async dynamicImportCustomReportModule(moduleName: string): Promise<any> {
        switch (`${moduleName}Module`) {
            case 'SalesDetailModule':
                return (
                    await import('@containers/reports/report/custom-reports/sales-detail-report/sales-detail-report.module')
                ).SalesDetailReportModule;
            case 'EmployeeAuditModule':
                return (
                    await import('@containers/reports/report/custom-reports/employee-audit-report/employee-audit-report.module')
                ).EmployeeAuditReportModule;
            case 'UberEatsModule':
                return (await import('@containers/reports/report/custom-reports/uber-eats-report/uber-eats.module'))
                    .UberEatsModule;
        }
    }

    public async dynamicImportAgGridReportModule(moduleName): Promise<any> {
        // possibly can be automated using RegEx for file path extraction:
        //
        // let baseName = moduleName.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? "-" : "") + $.toLowerCase())
        // let filePath = `@ag-grid-reports/${baseName}-report/${baseName}.module`;
        // let module = `${moduleName}Module`;
        // return (await import(filePath))?.[module];
        //
        switch (`${moduleName}Module`) {
            case 'TransferSummaryModule':
                return (await import('@ag-grid-reports/transfer-summary-report/transfer-summary.module'))
                    .TransferSummaryModule;
            case 'SuitePaymentModule':
                return (await import('@ag-grid-reports/suite-payment-report/suite-payment.module')).SuitePaymentModule;
            case 'SuiteOrderSummaryModule':
                return (await import('@ag-grid-reports/suite-order-summary-report/suite-order-summary.module'))
                    .SuiteOrderSummaryModule;
            case 'SuiteItemSalesModule':
                return (await import('@ag-grid-reports/suite-item-sales-report/suite-item-sales.module'))
                    .SuiteItemSalesModule;
            case 'SuiteCateringProductionModule':
                return (
                    await import('@ag-grid-reports/suite-catering-production-report/suite-catering-production.module')
                ).SuiteCateringProductionModule;
            case 'StandWorksheetClosingModule':
                return (await import('@ag-grid-reports/stand-worksheet-closing-report/stand-worksheet-closing.module'))
                    .StandWorksheetClosingModule;
            case 'RecipeDepletionsModule':
                return (await import('@ag-grid-reports/recipe-depletions-report/recipe-depletions.module'))
                    .RecipeDepletionsModule;
            case 'SalesOverShortModule':
                return (await import('@ag-grid-reports/sales-over-short-report/sales-over-short.module'))
                    .SalesOverShortModule;
            case 'SalesAndCountTransactionByTimeModule':
                return (
                    await import('@ag-grid-reports/sales-and-count-transaction-by-time-report/sales-and-count-transaction-by-time.module')
                ).SalesAndCountTransactionByTimeModule;
            case 'SalesAndLaborByTimeModule':
                return (
                    await import('@containers/reports/report/ag-grid-reports/sales-and-labor-by-time-report/sales-and-labor-by-time.module')
                ).SalesAndLaborByTimeModule;
            case 'ProductMixModule':
                return (await import('@ag-grid-reports/product-mix-report/product-mix.module')).ProductMixModule;
            case 'ProductListingModule':
                return (await import('@ag-grid-reports/product-listing-report/product-listing.module'))
                    .ProductListingModule;
            case 'PrimaryLaborByHourModule':
                return (await import('@ag-grid-reports/primary-labor-by-hour-report/primary-labor-by-hour.module'))
                    .PrimaryLaborByHourModule;
            case 'PhysicalTerminalSalesModule':
                return (await import('@ag-grid-reports/physical-terminal-sales-report/physical-terminal-sales.module'))
                    .PhysicalTerminalSalesModule;
            case 'PaidOutTipsDetailModule':
                return (await import('@ag-grid-reports/paid-out-tips-detail-report/paid-out-tips-detail.module'))
                    .PaidOutTipsDetailModule;
            case 'PaidInOutDetailModule':
                return (await import('@ag-grid-reports/paid-in-out-detail-report/paid-in-out-detail.module'))
                    .PaidInOutDetailModule;
            case 'OrderSummaryModule':
                return (await import('@ag-grid-reports/order-summary-report/order-summary.module')).OrderSummaryModule;
            case 'OrderPaymentsModule':
                return (await import('@ag-grid-reports/order-payments-report/order-payments.module'))
                    .OrderPaymentsModule;
            case 'OrderExplorerModule':
                return (await import('@ag-grid-reports/order-explorer-report/order-explorer.module'))
                    .OrderExplorerModule;
            case 'NotesQuestionsModule':
                return (await import('@ag-grid-reports/notes-questions-report/notes-questions.module'))
                    .NotesQuestionsModule;
            case 'LaborPerformanceByHourModule':
                return (
                    await import('@ag-grid-reports/labor-performance-by-hour-report/labor-performance-by-hour.module')
                ).LaborPerformanceByHourModule;
            case 'SpeedOfServiceCheckAuditModule':
                return (
                    await import('@ag-grid-reports/speed-of-service-check-audit-report/speed-of-service-check-audit.module')
                ).SpeedOfServiceCheckAuditModule;
            case 'SpeedOfServicePerformanceModule':
                return (
                    await import('@ag-grid-reports/speed-of-service-performance-report/speed-of-service-performance.module')
                ).SpeedOfServicePerformanceModule;
            case 'InventoryOnHandModule':
                return (await import('@ag-grid-reports/inventory-on-hand-report/inventory-on-hand.module'))
                    .InventoryOnHandModule;
            case 'InventoryItemListingModule':
                return (await import('@ag-grid-reports/inventory-item-listing-report/inventory-item-listing.module'))
                    .InventoryItemListingModule;
            case 'InventoryCountModule':
                return (await import('@ag-grid-reports/inventory-count-report/inventory-count.module'))
                    .InventoryCountModule;
            case 'GiftCardActivityModule':
                return (await import('@ag-grid-reports/gift-card-activity-report/gift-card-activity.module'))
                    .GiftCardActivityModule;
            case 'ItemCommentsModule':
                return (await import('@ag-grid-reports/item-comments-report/item-comments.module')).ItemCommentsModule;
            case 'MissedBreaksModule':
                return (await import('@ag-grid-reports/missed-breaks-report/missed-breaks.module')).MissedBreaksModule;
            case 'ModifierAnalysisByProductCategoryModule':
                return (
                    await import('@ag-grid-reports/modifier-analysis-by-product-category-report/modifier-analysis-by-product-category.module')
                ).ModifierAnalysisByProductCategoryModule;
            case 'EnterpriseSalesSummaryModule':
                return (
                    await import('@ag-grid-reports/enterprise-sales-summary-report/enterprise-sales-summary.module')
                ).EnterpriseSalesSummaryModule;
            case 'EmployeeScorecardModule':
                return (await import('@ag-grid-reports/employee-scorecard-report/employee-scorecard.module'))
                    .EmployeeScorecardModule;
            case 'EmployeeSalesModule':
                return (await import('@ag-grid-reports/employee-sales-report/employee-sales.module'))
                    .EmployeeSalesModule;
            case 'EmployeeDiscountModule':
                return (await import('@ag-grid-reports/employee-discount-report/employee-discount.module'))
                    .EmployeeDiscountModule;
            case 'DepositSummaryModule':
                return (await import('@ag-grid-reports/deposit-summary-report/deposit-summary.module'))
                    .DepositSummaryModule;
            case 'CashDrawerSummaryModule':
                return (await import('@ag-grid-reports/cash-drawer-summary-report/cash-drawer-summary.module'))
                    .CashDrawerSummaryModule;
            case 'AccountInvoiceModule':
                return (await import('@ag-grid-reports/account-invoice-report/account-invoice.module'))
                    .AccountInvoiceModule;
            case 'SuiteTipModule':
                return (await import('@ag-grid-reports/suite-tip-report/suite-tip.module')).SuiteTipModule;
            case 'ProductSoldByTimeModule':
                return (await import('@ag-grid-reports/product-sold-by-time-report/product-sold-by-time.module'))
                    .ProductSoldByTimeModule;
            case 'SuiteOrderAssignmentsModule':
                return (await import('@ag-grid-reports/suite-order-assignments-report/suite-order-assignments.module'))
                    .SuiteOrderAssignmentsModule;
            case 'ShippingModule':
                return (await import('@ag-grid-reports/shipping-report/shipping.module')).ShippingModule;
            case 'TransfersByItemModule':
                return (await import('@ag-grid-reports/transfers-by-item-report/transfers-by-item.module'))
                    .TransfersByItemModule;
            case 'LiabilityDetailModule':
                return (await import('@ag-grid-reports/liability-detail-report/liability-detail.module'))
                    .LiabilityDetailModule;
            case 'EmployeesOnTheClockModule':
                return (await import('@ag-grid-reports/employees-on-the-clock-report/employees-on-the-clock.module'))
                    .EmployeesOnTheClockModule;
            case 'PayrollHoursAndWageDetailModule':
                return (await import('@ag-grid-reports/payroll-hour-and-wage-report/payroll-hour-and-wage.module'))
                    .PayrollHourAndWageModule;
            case 'PayrollSummaryModule':
                return (await import('@ag-grid-reports/payroll-summary-report/payroll-summary.module'))
                    .PayrollSummaryModule;
            case 'VoidsSummaryModule': //* intentional tiny discrepancy in case's string and module name
                return (await import('@ag-grid-reports/void-summary-report/void-summary.module')).VoidSummaryModule;
            case 'VoidSummaryDetailModule':
                return (await import('@ag-grid-reports/ag-grid-details/void-summary-detail/void-summary-detail.module'))
                    .VoidSummaryDetailModule;
            case 'NoSaleByEmployeeModule':
                return (await import('@ag-grid-reports/no-sale-by-employee-report/no-sale-by-employee.module'))
                    .NoSaleByEmployeeModule;
            case 'IdleTimeTrackingModule':
                return (await import('@ag-grid-reports/idle-time-tracking-report/idle-time-tracking.module'))
                    .IdleTimeTrackingModule;
            case 'DiscountSummaryModule':
                return (await import('@ag-grid-reports/discount-summary-report/discount-summary.module'))
                    .DiscountSummaryModule;
            case 'DiscountSummaryDetailModule':
                return (
                    await import('@ag-grid-reports/ag-grid-details/discount-summary-detail/discount-summary-detail.module')
                ).DiscountSummaryDetailModule;
            case 'DiscountedItemsByReportingCategoryModule':
                return (
                    await import('@ag-grid-reports/discounted-items-by-reporting-category-report/discounted-items-by-reporting-category.module')
                ).DiscountedItemsByReportingCategoryModule;
            case 'PhysicalSalesAccountingModule':
                return (
                    await import('@ag-grid-reports/physical-sales-accounting-report/physical-sales-accounting.module')
                ).PhysicalSalesAccountingModule;
            case 'CreditCardExpirationModule':
                return (await import('@ag-grid-reports/credit-card-expiration-report/credit-card-expiration.module'))
                    .CreditCardExpirationModule;
            case 'InventoryPurchaseSummaryModule':
                return (
                    await import('@ag-grid-reports/inventory-purchase-summary-report/inventory-purchase-summary.module')
                ).InventoryPurchaseSummaryModule;
            case 'TransferPickSheetModule':
                return (await import('@ag-grid-reports/transfer-pick-sheet-report/transfer-pick-sheet.module'))
                    .TransferPickSheetModule;
            case 'CategorySalesPerSiteModule':
                return (
                    await import('@ag-grid-reports/product-sales-by-category-report/product-sales-by-category.module')
                ).ProductSalesByCategoryModule;
            case 'WeeklySalesAndLaborHistoryModule':
                return (
                    await import('@ag-grid-reports/weekly-sales-and-labor-history/weekly-sales-and-labor-history.module')
                ).WeeklySalesAndLaborHistoryModule;
            case 'InventoryCostOfGoodsSoldModule':
                return (
                    await import('@containers/reports/report/ag-grid-reports/inventory-cost-of-goods-sold-report/inventory-cost-of-goods-sold.module')
                ).InventoryCostOfGoodsSoldModule;
            case 'WeeklySalesModule':
                return (await import('@ag-grid-reports/weekly-sales-report/weekly-sales.module')).WeeklySalesModule;
            case 'CashDrawerTransactionHistoryModule':
                return (
                    await import('@ag-grid-reports/cash-drawer-summary-report/cash-drawer-transaction-history/cash-drawer-transaction-history.module')
                ).CashDrawerTransactionHistoryModule;
            case 'LaborPerformanceModule':
                return (
                    await import('@ag-grid-reports/labor-performance-summary-report/labor-performance-summary.module')
                ).LaborPerformanceSummaryModule;
            case 'IrisPayrollSummaryModule':
                return (await import('@ag-grid-reports/iris-payroll-summary-report/iris-payroll-summary.module'))
                    .IrisPayrollSummaryModule;
            case 'DepositDetailModule':
                return (await import('@ag-grid-reports/deposit-summary-report/deposit-detail/deposit-detail.module'))
                    .DepositDetailModule;
            case 'WebSrmModule':
                return (await import('@ag-grid-reports/web-srm-report/web-srm.module')).WebSRMModule;
            case 'LaborPerformanceByUserModule':
                return (
                    await import('@ag-grid-reports/labor-performance-by-user-report/labor-performance-by-user.module')
                ).LaborPerformanceByUserModule;
            case 'UnavailableProductsModule':
                return (await import('@ag-grid-reports/unavailable-products-report/unavailable-products.module'))
                    .UnavailableProductsModule;
            case 'UnavailableProductsDetailModule':
                return (
                    await import('@ag-grid-reports/ag-grid-details/unavailable-products-detail/unavailable-products-detail.module')
                ).UnavailableProductsDetailModule;
            case 'TaxExemptSalesModule':
                return (await import('@ag-grid-reports/tax-exempt-sales-report/tax-exempt-sales.module'))
                    .TaxExemptSalesModule;
            case 'TimecardAuditModule':
                return (await import('@ag-grid-reports/timecard-audit-report/timecard-audit.module'))
                    .TimecardAuditModule;
        }
    }

    public async dynamicImportAgChartReportModule(moduleName): Promise<any> {
        switch (`${moduleName}Module`) {
            case 'SpeedOfServiceModule':
                return (
                    await import('@containers/reports/report/ag-chart-reports/speed-of-service-report/speed-of-service.module')
                ).SpeedOfServiceModule;
            case 'SalesAnalysisModule':
                return (
                    await import('@containers/reports/report/ag-chart-reports/sales-analysis/sales-analysis.module')
                ).SalesAnalysisModule;
        }
    }
}
